import { Nav, Footer } from "@/components/Nav";
import { useLang } from "@/i18n/LanguageContext";

export default function Privacy() {
    const { t, lang } = useLang();
    const locale = lang === "en" ? "en-GB" : "it-IT";
    const headers = t("privacy.tblHead");
    const rows = t("privacy.tblRows");
    return (
        <div className="min-h-screen bg-[#15181C] text-[#F4F2ED]">
            <Nav />
            <div className="max-w-3xl mx-auto px-5 md:px-8 py-10">
                <div className="text-xs uppercase tracking-[0.3em] text-[#9AA2AD] mb-2">{t("privacy.docLabel")}</div>
                <h1 className="font-display text-5xl md:text-6xl uppercase mb-8">{t("privacy.title1")}<br /><span className="text-[#E2231A]">{t("privacy.title2")}</span></h1>
                <div className="space-y-6 text-sm leading-relaxed">
                    <p className="text-[#9AA2AD]"><em>{t("privacy.note")}: {new Date().toLocaleDateString(locale)}</em></p>

                    <h2 className="font-display text-2xl uppercase">{t("privacy.h1")}</h2>
                    <p dangerouslySetInnerHTML={{ __html: t("privacy.p1") }} />

                    <h2 className="font-display text-2xl uppercase">{t("privacy.h2")}</h2>
                    <ul className="list-disc pl-6 space-y-1">
                        {["li2_1","li2_2","li2_3","li2_4","li2_5","li2_6","li2_7"].map(k => (
                            <li key={k} dangerouslySetInnerHTML={{ __html: t("privacy." + k) }} />
                        ))}
                    </ul>

                    <h2 className="font-display text-2xl uppercase">{t("privacy.h3")}</h2>
                    <div className="border border-[#9AA2AD]/20 overflow-x-auto">
                        <table className="w-full text-xs">
                            <thead className="bg-[#1C2026] text-[#9AA2AD] uppercase tracking-widest text-[10px]">
                                <tr>{headers.map((h, i) => <th key={i} className="p-2 text-left">{h}</th>)}</tr>
                            </thead>
                            <tbody>
                                {rows.map((row, i) => (
                                    <tr key={i} className="border-t border-[#9AA2AD]/10">
                                        {row.map((c, j) => <td key={j} className="p-2">{c}</td>)}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <h2 className="font-display text-2xl uppercase">{t("privacy.h4")}</h2>
                    <ul className="list-disc pl-6 space-y-1">
                        {["li4_1","li4_2","li4_3","li4_4","li4_5"].map(k => (
                            <li key={k} dangerouslySetInnerHTML={{ __html: t("privacy." + k) }} />
                        ))}
                    </ul>
                    <p>{t("privacy.p4")}</p>

                    <h2 className="font-display text-2xl uppercase">{t("privacy.h5")}</h2>
                    <p>{t("privacy.p5")}</p>

                    <h2 className="font-display text-2xl uppercase">{t("privacy.h6")}</h2>
                    <p dangerouslySetInnerHTML={{ __html: t("privacy.p6") }} />

                    <h2 className="font-display text-2xl uppercase">{t("privacy.h7")}</h2>
                    <p dangerouslySetInnerHTML={{ __html: t("privacy.p7") }} />

                    <h2 className="font-display text-2xl uppercase">{t("privacy.h8")}</h2>
                    <p dangerouslySetInnerHTML={{ __html: t("privacy.p8") }} />
                </div>
            </div>
            <Footer />
        </div>
    );
}
